import {
  APEX_CLASS,
  APEX_TRIGGER,
  APPROVAL_PROCESS,
  FIELD,
  FLOW,
  LAYOUT,
  PROCESS_BUILDER_FLOW,
  RECORD_TYPE,
  VALIDATION_RULE,
  WORKFLOW_RULE,
} from '@server/parser';

//TODO fix SalesforceItem imports in separate PR
import type { SalesforceItem } from './ConfigurationItemTypes';
export * from './ConfigurationItemTypes';
export type { SalesforceItem, SalesforceItemBase } from './ConfigurationItemTypes';
export type { DocumentationItem } from '../../types/documentation-item';

// ******* BE types *******
export interface OpenAiResponse {
  data: string;
  error: string;
}

export type NameProperties = { name: string; label: string };

export interface LeadingFieldData {
  name: string;
  label: string;
  values: LeadingFieldValue[];
}

export type SfdcLeadStatusMetadata = {
  converted: boolean;
};

export type SfdcCaseStatusMetadata = {
  closed: boolean;
};

export enum OpportunityStageMetadataForecastCategory {
  COMMIT = 'Forecast', // label is Commit, value is Forecast
  OMITTED = 'Omitted',
  PIPELINE = 'Pipeline',
  BEST_CASE = 'BestCase', // label is `Best Case` value is BestCase
  CLOSED = 'Closed',
  MOST_LIKELY = 'MostLikely',
}

export type SfdcOpportunityStageMetadata = {
  won: boolean;
  closed: boolean;
  probability: number;
  forecastCategory: OpportunityStageMetadataForecastCategory;
};

export type SfdcStageMetadata =
  | SfdcCaseStatusMetadata
  | SfdcLeadStatusMetadata
  | SfdcOpportunityStageMetadata;

export type StageMetadataOptions = Partial<
  SfdcLeadStatusMetadata & SfdcCaseStatusMetadata & SfdcOpportunityStageMetadata
>;

//TODO check this
export type LeadingFieldValue = NameProperties & {
  metadata?: { default: boolean } & StageMetadataOptions;
  [VALIDATION_RULE]?: string[];
  [FLOW]?: string[];
  [PROCESS_BUILDER_FLOW]?: string[];
  [WORKFLOW_RULE]?: string[];
  [APPROVAL_PROCESS]?: string[];
};

// ----- client types -----
export interface RelatedObjectsMap {
  [objectName: string]: SalesforceItem[];
}

export type FieldValue = {
  name: string;
  label: string;
  validationRules?: string[];
  flows?: string[];
  workflowRules?: string[];
  approvalProcesses?: string[];
  processBuilderFlows?: string[];
  apexTriggers?: string[]; //preparation for when supported by BE
  paths?: string[]; //preparation for when supported by BE
  cpqData?: string[];
  layouts?: string[];
};

export const PARSER_BASE_TYPES = [
  VALIDATION_RULE,
  APPROVAL_PROCESS,
  WORKFLOW_RULE,
  FLOW,
  PROCESS_BUILDER_FLOW,
  APEX_TRIGGER,
  APEX_CLASS,
  FIELD,
  RECORD_TYPE,
  LAYOUT,
];

export type OpenAiDescription = {
  type: 'error' | 'data';
  text: string;
};

//This type is for the API call: POST /parser  (the BE should unite the objectType types....)
export type ObjectType = {
  name: string;
  label?: string; //TBD if we need it here as we're displaying SF objects instead
  favorite: boolean;
};

export type ParserItemsMap = {
  [type in string]: string[];
};

/**
 * ConfigurationItemWithStatus adds a status field to any configuration item type
 * while maintaining type safety from the discriminated union.
 */
export type ConfigurationItemWithStatus = SalesforceItem & {
  status: 'Active' | 'Inactive';
};
